import React, { useEffect, useState } from "react";
import { imgBaseUrl } from "../../../api/api";
import { formatToDate } from "../../master/FormatToDateTime";
import "./StudentAdmissionFrom1.css";

export default function StudentAdmissionFrom2({ data }) {
  const [setting, setSetting] = useState({});

  useEffect(() => {
    setSetting(JSON.parse(localStorage.getItem("setting") ?? {}));
  }, []);

  const subjects =
    typeof data?.student_batch_info?.subjects === "string"
      ? JSON.parse(data?.student_batch_info?.subjects)
      : data?.student_batch_info?.subjects;
  return (
    <>
      <style>
        {`
            .a4-page-admission::before{
                background-image: url(${imgBaseUrl + setting?.logo_img});
            }
        `}
      </style>

      <div className="a4-page-admission p-3" id="PrintDiv">
        <div className="row g-4 overflow-hidden">
          {setting?.student_admission_header_logo ? (
            <div className="col-12 text-center">
              <img
                src={imgBaseUrl + setting?.student_admission_header_logo}
                alt=""
                style={{ width: "60%" }}
              />
            </div>
          ) : (
            <>
              <div className="col-12">
                <div className="d-flex align-items-center justify-content-center">
                  <img
                    src={imgBaseUrl + setting?.logo_img}
                    style={{ width: "200px", height: "100px", objectFit: "contain" }}
                    alt=""
                  />
                  <div className="text-center">
                    <p className="m-0 ri-30px fw-bold">{setting?.name}</p>
                    <p className="m-0 ri-16px fw-bold">
                      {setting?.village} {setting?.district} {setting?.state}{" "}
                      {setting?.pin_code}
                    </p>
                    <p className="m-0 ri-16px fw-bold">
                      Mobile No : {setting?.mobile}{" "}
                      {setting?.secondary_mobile &&
                        `, ${setting?.secondary_mobile}`}{" "}
                    </p>
                    <p className="m-0 ri-16px fw-bold">
                      Email : {setting?.email}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 mt-1 mb-0">
                <div className="row align-items-center justify-content-center">
                  <div className="col-4">
                    <span className="badge bg-primary fs-6 text-white">
                      Student Admission Form
                    </span>
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="col-12 mt-0">
            <div className="row align-items-end me-0 pe-0">
              <div className="col-9">
                <div className="row">
                  <div className="col-5">
                    <div className="row g-2 me-0 pe-0">
                      <div className="col-5 fw-bold pb-1">Session</div>
                      <div className="col-7 border border-dark rounded-1">
                        {data?.student_batch_info?.session_year?.session ??
                          ""}
                      </div>

                      <div className="col-5 fw-bold pb-1">Class</div>
                      <div className="col-7 border border-dark rounded-1">
                        {" "}
                        {data?.student_batch_info?.course?.title ?? ""}
                      </div>
                      <div className="col-5 fw-bold pb-1">Medium</div>
                      <div className="col-7 border border-dark rounded-1">
                        {data?.medium}
                      </div>
                    </div>
                  </div>
                  <div className="col-7">
                    <div className="row g-2 me-0 pe-0 ">
                      <div className="col-6 fw-bold pb-1">Registration No</div>
                      <div className="col-6 border border-dark rounded-1">
                        {data?.registration_no ?? ""}
                      </div>
                      <div className="col-6 fw-bold pb-1">Date of Admission</div>
                      <div className="col-6 border border-dark rounded-1">
                        {formatToDate(data?.admission_date) ?? ""}
                      </div>
                      <div className="col-6 fw-bold pb-1">Gender</div>
                      <div className="col-6 border border-dark rounded-1">
                        {data?.gender}
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row me-0 pe-0 mt-2">
                      <div className="col-2 fw-bold pb-1">Name</div>
                      <div className="col-10 border border-dark rounded-1">
                        {data?.name}
                      </div>
                    </div>
                    <div className="row me-0 pe-0 mt-2">
                      <div className="col-2 fw-bold pb-1">Aadhar No</div>
                      <div className="col-10 border border-dark rounded-1">
                        {data?.aadhar}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-auto">
                {data?.profile_picture ? (
                  <img
                    src={imgBaseUrl + data?.profile_picture}
                    className="profile_image"
                    alt=""
                  />
                ) : (
                  <img src="/files/user2.png" className="profile_image" alt="" />
                )}
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="row me-0 pe-0 mb-2">
              <div className="col-3 fw-bold pb-1">Mobile No</div>
              <div className="col-9 border border-dark rounded-1">
                {data?.phone}{" "}
                {data?.secondary_mobile && `, ${data?.secondary_mobile}`}
              </div>
            </div>
            <div className="row me-0 pe-0 mb-2">
              <div className="col-3 fw-bold pb-1">Category</div>
              <div className="col-5 border border-dark  rounded-1">
                {data?.category}
              </div>
              <div className="col-2 fw-bold pb-1 text-end">RTE Status</div>
              <div className="col-2 border border-dark rounded-1">
                {" "}
                {data?.student_batch_info?.rte_status}
              </div>
            </div>
          </div>
          <div className="row me-0 pe-0 mb-2">
            <div className="col-3 fw-bold pb-1">Date of Birth</div>
            <div className="col-5 border border-dark rounded-1">
              {formatToDate(data?.dob)}
            </div>
            <div className="col-2 fw-bold pb-1 text-end">Hostel</div>
            <div className="col-2 border border-dark rounded-1">
              {" "}
              {data?.hostel_status}
            </div>
          </div>
          <div className="row me-0 pe-0 mb-2">
            <div className="col-3 fw-bold pb-1">Father’s Name</div>
            <div className="col-9 border border-dark rounded-1">
              {data?.father_name}
            </div>
          </div>
          <div className="row me-0 pe-0 mb-2">
            <div className="col-3 fw-bold pb-1">Mother’s Name</div>
            <div className="col-9 border border-dark rounded-1">
              {data?.mother_name}
            </div>
          </div>
          <div className="row me-0 pe-0 mb-2">
            <div className="col-3 fw-bold pb-1">Father’s Occupation</div>
            <div className="col-9 border border-dark rounded-1">
              {data?.father_occupation}
            </div>
          </div>
          <div className="row me-0 pe-0 mb-2">
            <div className="col-3 fw-bold pb-1">Permanent Address</div>
            <div className="col-9 border border-dark rounded-1">
              {[data?.village, data?.district, data?.state, data?.zipcode]
                .filter(Boolean)
                .join(", ")}
            </div>
          </div>
          <div className="row me-0 pe-0 mb-2">
            <div className="col-3 fw-bold pb-1">Present Address</div>
            <div className="col-9 border border-dark rounded-1">
              {[data?.village, data?.district, data?.state, data?.zipcode]
                .filter(Boolean)
                .join(", ")}
            </div>
          </div>
          <div className="col-12">
            <div className="row me-0 pe-0 mb-1">
              <div className="col-12 fw-bold mb-1">
                Subjects You wish to study at the institute
              </div>
              <div className="col-3"></div>
              <div className="col-9 mb-0">
                <div className="row" style={{ minHeight: "100px" }}>
                  {subjects?.map((subject, i) => (
                    <p
                      className={`${subjects?.length > 4 ? " col-6 " : "col-12"
                        } mb-1`}
                    >
                      {i + 1}.{" "}
                      {subject && typeof subject === "string"
                        ? JSON.parse(subject)?.name
                        : subject?.name}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <p>
              I{" "}
              <span
                className="border-dashed border-top-0 border-end-0 border-start-0 d-inline-block"
                style={{ width: "260px" }}
              ></span>{" "}
              here by declare that the Information given is correct to my
              knowledge I also promise to abide by the rules and regulation of
              the institute. failing which my registration Can be cancelled &
              the fees will be forfeited.
            </p>
          </div>
          <div className="col-12">
            <div className="row mt-4 mb-0">
              <div className="col-1"></div>
              <div className="col-3">Educational Background</div>
              <div className="col-4"></div>
              <div className="col-3 text-end">Signature For Student</div>
              <div className="col-1"></div>
            </div>
            <table className="table table-bordered mt-1">
              <thead>
                <tr>
                  <th>Name of Examination</th>
                  <th>Name of the School</th>
                  <th>Year</th>
                  <th>% Marks Obt. </th>
                </tr>
              </thead>
              <tbody>
                {data?.education_details
                  ? JSON.parse(data.education_details)?.map((detail, i) => (
                    <tr key={i}>
                      <td>{detail?.course_name}</td>
                      <td>{detail?.school_name}</td>
                      <td>{detail?.year}</td>
                      <td>{detail?.score}</td>
                    </tr>
                  ))
                  : [1, 2, 3]?.map((detail, i) => (
                    <tr key={i}>
                      <td className="py-4"></td>
                      <td className="py-4"></td>
                      <td className="py-4"></td>
                      <td className="py-4"></td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <div className="row mt-10 mb-1">
              <div className="col-4">
                <div style={{ height: "40px" }}></div>

                <div className="fw-bold">
                  Signature For Student
                </div>
              </div>

              <div className="col-4"></div>

              <div className="col-4 text-end">
                {setting?.auto_signature === "Yes" &&
                  setting?.signature && (
                    <div className="mb-2">
                      <img
                        src={imgBaseUrl + setting.signature}
                        alt="Signature"
                        style={{
                          width: "120px",
                          height: "40px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  )}

                <div className="fw-bold">
                  Signature For Parents/Guardians
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <p className="text-center fw-bold">
              Note : Fee once Deposited will not be refunded or adjusted.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
